import {
  subWorkLog,
  getNoticeList,
  updateNoticeReadStatus,
  getWorkLogoDetail
} from '@/services/record'

export default {
  namespaced: true,
  state: {
    setSubmitting: false,
    preWorkLogo: {},
    noticeList: [],
    noticeTotal: 0,
    page: 0,
    loadingContent: true,
    // 数据是否已经加载完毕
    loadingComplete: false,
    // 日志是否已经添加完毕
    addComplete: false
  },
  mutations: {
    setSubmitting (state, type) {
      state.setSubmitting = type
    },
    setAddComplete (state, type) {
      state.addComplete = type
    },
    setWorkLogo (state, data) {
      state.preWorkLogo = data
    },
    setNoticeList (state, data) {
      if (data.length === 0) {
        state.noticeList = data
        return
      }
      if (state.noticeList.length === 0) {
        state.noticeList.push(...data)
      } else {
        for (let i = 0; i < state.noticeList.length; i++) {
          let item = state.noticeList[i]
          for (let k = 0; k < data.length; k++) {
            let oItem = data[k]
            if (item.id === oItem.id) {
              data.splice(k, 1)
              break
            }
          }
        }
        data.length > 0 && state.noticeList.push(...data)
      }
    },
    setNoticeTotal (state, total) {
      state.noticeTotal = total
    },
    updateNoticeItem (state, data) {
      const { id, index } = data
      // console.log(id, index)
      if (state.noticeList[index] && state.noticeList[index].id === id) {
        state.noticeList[index].isread = 1
      } else {
        state.noticeList = state.noticeList.map(item => {
          if (item.id === id) {
            item.isread = 1
          }
          return item
        })
      }
    },
    setPage (state, page) {
      state.page = parseInt(page)
    },
    setLoadingContent (state, data) {
      state.loadingContent = data
    },
    setLoadingComplete (state, data) {
      state.loadingComplete = data
    }
  },
  actions: {
    async getWorkLogoInfo ({ commit }) {
      commit('setLoadingContent', true)
      const chain = await getWorkLogoDetail()
        .onSuccess(res => {
          commit('setWorkLogo', res)
        })
        .onNetComplete(() => {
          commit('setLoadingContent', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 新增工作记录
    async addWorkLog ({ commit }) {
      commit('setSubmitting', true)
      commit('setAddComplete', true)
      const chain = await subWorkLog()
        .onNetComplete(() => {
          commit('setSubmitting', false)
          setTimeout(() => {
            commit('setAddComplete', false)
          }, 1000)
        })
        .config({ tip: false })
      return chain
    },
    async getNoticeData ({ commit }, page = 1) {
      commit('setLoadingContent', true)
      commit('setLoadingComplete', false)
      if (page === 1) {
        commit('setNoticeList', [])
        commit('setNoticeTotal', 0)
      }
      const chain = await getNoticeList()
        .params({ page })
        .onSuccess(res => {
          const { list, count } = res
          let lList = list.length
          /* // test
          list[0].isread = 0 */
          if (lList > 0) {
            commit('setNoticeList', list)
            commit('setNoticeTotal', count)
          }
          lList === 0 && commit('setLoadingComplete', true)
        })
        .onNetComplete(() => {
          commit('setLoadingContent', false)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 更新通知阅读状态
    async updateNoticeStatus ({ commit }, data) {
      commit('setSubmitting', true)
      const { id } = data
      const chain = await updateNoticeReadStatus()
        .params({ id })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    // 初始化通知记录状态
    initNoticeStore ({ commit }) {
      commit('setPage', 0)
      commit('setNoticeTotal', 0)
      commit('setNoticeList', [])
    }
  }
}
